$(function () {
    $('.prodLink').on('click', function (e) {
        const itemID=$(this).data('itemid');
        if (catItems[itemID]!==undefined){
            const clicked_item = {
                item_id: catItems[itemID].item_id,
                item_name: catItems[itemID].item_name,
                affiliation: catItems[itemID].affiliation,
                price: catItems[itemID].price,
                discount: catItems[itemID].discount,
                subscription: catItems[itemID].subscription,
                item_brand: catItems[itemID].item_brand,
                item_category:catItems[itemID].item_category,
                index: catItems[itemID].index,
                item_list_id: catItems[itemID].item_list_id,
                item_list_name: catItems[itemID].item_list_name,
            }
            selectItem(clicked_item);
        }
    })
})
const catItems=[];
const event_items = [];
let stopDLPush=false;
function selectItem(clicked_item: { item_id: string; item_name: string; affiliation: string; discount: number; price: number; index: number; item_brand: string; item_category: string; subscription: string; item_list_id: string; item_list_name: string; }){
    if (!stopDLPush){
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            event: "select_item",
            ecommerce: {
            item_list_id: clicked_item.item_list_id,
            item_list_name: clicked_item.item_list_name,
            items: clicked_item
            }
        });
    }
    stopDLPush=true;
}